{
  "familyId": "TOPO-WERELD-HOOFDST",
  "questions": [
    {
      "id": "TOPO-WERELD-HOOFDST-001",
      "familyId": "TOPO-WERELD-HOOFDST",
      "module": "Topo",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "wereld",
      "subSkill": "topo_hoofdsteden_wereld",
      "questionType": "multiple_choice",
      "question": "Wat is de hoofdstad van de Verenigde Staten?",
      "options": ["Washington D.C.", "New York City", "Los Angeles", "Chicago"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoofdstad ≠ grootste stad",
            "content": "De hoofdstad is de stad waar de regering zetelt. Dat is niet altijd de grootste of bekendste stad. In de VS is Washington D.C. de hoofdstad, maar New York is de grootste stad.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "wereld_hoofdstad_vs",
      "variantIndex": 1,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.76,
      "pedagogy": {
        "dok": 2
      },
      "feedback": {
        "explanationText": "Washington D.C. is de hoofdstad van de Verenigde Staten. Daar staat het Witte Huis en het Capitool. New York is de grootste stad, maar niet de hoofdstad.",
        "solutionSteps": [
          "Hoofdstad VS = Washington D.C.",
          "Daar zetelt de regering (Witte Huis, Capitool)",
          "New York is de grootste stad, maar niet de hoofdstad"
        ],
        "distractorExplanations": {
          "0": "Goed! Washington D.C. is de hoofdstad van de VS.",
          "1": "New York is de grootste stad van de VS, maar niet de hoofdstad. De regering zetelt in Washington D.C.",
          "2": "Los Angeles is een grote stad aan de westkust, maar niet de hoofdstad.",
          "3": "Chicago is een grote stad in het midden van de VS, maar niet de hoofdstad."
        }
      }
    },
    {
      "id": "TOPO-WERELD-HOOFDST-002",
      "familyId": "TOPO-WERELD-HOOFDST",
      "module": "Topo",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "wereld",
      "subSkill": "topo_hoofdsteden_wereld",
      "questionType": "multiple_choice",
      "question": "Wat is de hoofdstad van Australië?",
      "options": ["Canberra", "Sydney", "Melbourne", "Brisbane"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Australië: hoofdstad vs grootste stad",
            "content": "Canberra is de hoofdstad van Australië. Sydney en Melbourne streden om de titel, dus werd een nieuwe stad gebouwd: Canberra, precies ertussenin.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "wereld_hoofdstad_australie",
      "variantIndex": 2,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "Canberra is de hoofdstad van Australië. Sydney en Melbourne zijn groter en bekender, maar Canberra werd speciaal gebouwd als hoofdstad omdat Sydney en Melbourne het niet eens konden worden.",
        "solutionSteps": [
          "Hoofdstad Australië = Canberra",
          "Sydney = grootste stad, maar niet de hoofdstad",
          "Canberra werd speciaal als hoofdstad gebouwd"
        ],
        "distractorExplanations": {
          "0": "Goed! Canberra is de hoofdstad van Australië.",
          "1": "Sydney is de grootste en bekendste stad van Australië (Opera House!), maar niet de hoofdstad.",
          "2": "Melbourne is de op één na grootste stad, maar niet de hoofdstad.",
          "3": "Brisbane is een grote stad in het noordoosten, maar niet de hoofdstad."
        }
      }
    },
    {
      "id": "TOPO-WERELD-HOOFDST-003",
      "familyId": "TOPO-WERELD-HOOFDST",
      "module": "Topo",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "wereld",
      "subSkill": "topo_hoofdsteden_wereld",
      "questionType": "multiple_choice",
      "question": "Welke stad is de hoofdstad van Japan?",
      "options": ["Tokio", "Osaka", "Kyoto", "Hiroshima"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Japan",
            "content": "Tokio is de hoofdstad van Japan en een van de grootste steden ter wereld. Kyoto was vroeger de hoofdstad (tot 1868).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "wereld_hoofdstad_japan",
      "variantIndex": 3,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Tokio is de hoofdstad van Japan. Het is een van de grootste steden ter wereld met meer dan 13 miljoen inwoners. Kyoto was de oude hoofdstad tot 1868.",
        "solutionSteps": [
          "Hoofdstad Japan = Tokio",
          "Tokio = een van de grootste steden ter wereld",
          "Kyoto = oude hoofdstad (tot 1868)"
        ],
        "distractorExplanations": {
          "0": "Goed! Tokio is de hoofdstad van Japan.",
          "1": "Osaka is de derde stad van Japan, maar niet de hoofdstad.",
          "2": "Kyoto was de oude hoofdstad van Japan (tot 1868), maar nu is dat Tokio.",
          "3": "Hiroshima is bekend vanwege de Tweede Wereldoorlog, maar is niet de hoofdstad."
        }
      }
    },
    {
      "id": "TOPO-WERELD-HOOFDST-004",
      "familyId": "TOPO-WERELD-HOOFDST",
      "module": "Topo",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "wereld",
      "subSkill": "topo_hoofdsteden_wereld",
      "questionType": "multiple_choice",
      "question": "Welke stad is NIET de hoofdstad van het land waar het in ligt?",
      "options": ["São Paulo (Brazilië)", "Peking (China)", "New Delhi (India)", "Kairo (Egypte)"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Strikvraag: grootste stad ≠ hoofdstad",
            "content": "São Paulo is de grootste stad van Brazilië, maar de hoofdstad is Brasília. Peking, New Delhi en Kairo zijn wél de hoofdsteden van hun land.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "wereld_hoofdstad_strikvraag",
      "variantIndex": 4,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.65,
      "feedback": {
        "explanationText": "São Paulo is de grootste stad van Brazilië, maar de hoofdstad is Brasília (speciaal gebouwd als hoofdstad in 1960). Peking is de hoofdstad van China, New Delhi van India, en Kairo van Egypte.",
        "solutionSteps": [
          "São Paulo = grootste stad Brazilië, maar NIET de hoofdstad",
          "Hoofdstad Brazilië = Brasília",
          "Peking = hoofdstad China ✓",
          "New Delhi = hoofdstad India ✓",
          "Kairo = hoofdstad Egypte ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! São Paulo is niet de hoofdstad van Brazilië — dat is Brasília.",
          "1": "Peking (Beijing) is wél de hoofdstad van China.",
          "2": "New Delhi is wél de hoofdstad van India.",
          "3": "Kairo is wél de hoofdstad van Egypte."
        }
      }
    },
    {
      "id": "TOPO-WERELD-HOOFDST-005",
      "familyId": "TOPO-WERELD-HOOFDST",
      "module": "Topo",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "wereld",
      "subSkill": "topo_hoofdsteden_wereld",
      "questionType": "matching",
      "question": "Koppel elk land aan de juiste hoofdstad.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "China", "right": "Peking" },
          { "left": "Brazilië", "right": "Brasília" },
          { "left": "Canada", "right": "Ottawa" },
          { "left": "Egypte", "right": "Kairo" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wereldhoofdsteden",
            "content": "Let op: de hoofdstad is niet altijd de grootste stad! China → Peking, Brazilië → Brasília (niet São Paulo!), Canada → Ottawa (niet Toronto!), Egypte → Kairo.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "wereld_hoofdstad_match",
      "variantIndex": 5,
      "citoDifficulty": 0.43,
      "citoDiscrimination": 0.67,
      "feedback": {
        "explanationText": "China → Peking, Brazilië → Brasília, Canada → Ottawa, Egypte → Kairo. Let op: Toronto is de grootste stad van Canada, maar Ottawa is de hoofdstad.",
        "solutionSteps": [
          "China → Peking (Beijing)",
          "Brazilië → Brasília (niet São Paulo!)",
          "Canada → Ottawa (niet Toronto!)",
          "Egypte → Kairo"
        ]
      }
    }
  ]
}